exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1qBZz{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._1gZln{padding-left:0;list-style-type:none}._1HNpQ{display:block;padding:6px 0;font-size:16px;color:#767676;text-decoration:none}._1HNpQ:active,._1HNpQ:hover{text-decoration:none;color:#585858}._1HNpQ:active{font-weight:700}a{text-decoration:none}a,a:hover{color:#149ce9}a:hover{cursor:pointer}._349wy{border-radius:0;width:100%;display:block;color:#585858;font-size:16px;border-bottom:1px solid #dce0e0}._3rPnz,.RswDz{margin-bottom:0}._3rPnz{padding-left:0;list-style:none;color:#585858}._2mCrc{text-transform:capitalize;font-size:12px}._3rquL{font-size:14px;line-height:1.43}._2YQXm{margin-bottom:24px}._1xG9Q{border-color:#c4c4c4;background:#fff;color:#585858;margin-bottom:0;border-radius:4px;border:1px solid;text-align:center;vertical-align:middle;font-weight:700;line-height:1.43;white-space:normal;cursor:pointer;max-width:280px;width:100%}._1xG9Q:focus,._1xG9Q:hover{border-color:#aaa;color:#585858;text-decoration:none}._35wpQ{border-color:#35baef;background-color:#35baef;color:#fff}.G1pw8{display:block;white-space:normal;padding:7px 21px}._35wpQ:active,._35wpQ:active:focus,._35wpQ:active:hover,._35wpQ:focus,._35wpQ:hover{border-color:#35baef;background-color:#35baef;color:#fff}._2iMKz,._2iMKz:active,._2iMKz:active:focus,._2iMKz:active:hover,._2iMKz:focus,._2iMKz:hover{border-color:#35baef;color:#35baef;background-color:#fff}._17R3V{color:#585858;font-size:14px}._1lkmG{border-bottom:1px solid #dce0e0}.Wk7u1{display:table;position:relative}._17Izq{float:left}._1HMl8 ._17Izq{margin-right:15px}._1XBRa{-webkit-backface-visibility:hidden;backface-visibility:hidden;position:relative;display:inline-block;overflow:hidden;background-color:#bbb;border-radius:50%;border:2px solid #fff}.TQTL8{border:0 none!important}._3cnFM{border-radius:0;width:100%;display:block;color:#585858;padding:15px;font-size:14px;line-height:1.43}", ""]);

// exports
exports.locals = {
	"errorMessage": "_1qBZz",
	"listContainer": "_1gZln",
	"sideNavitem": "_1HNpQ",
	"panelHeader": "_349wy",
	"tableBottom": "RswDz",
	"listLayout": "_3rPnz",
	"labelText": "_2mCrc",
	"description": "_3rquL",
	"space4": "_2YQXm",
	"button": "_1xG9Q",
	"btnPrimary": "_35wpQ",
	"btnlarge": "G1pw8",
	"btnPrimaryBorder": "_2iMKz",
	"sectionTitleLight": "_17R3V",
	"rowBorder": "_1lkmG",
	"mediaContainer": "Wk7u1",
	"pullLeft": "_17Izq",
	"photo": "_1HMl8",
	"profileAvatarLink": "_1XBRa",
	"noBorder": "TQTL8",
	"panelNolist": "_3cnFM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Reservation/Reservation.css
// module id = 2561
// module chunks = 15